import React, { useState, useContext } from 'react'
import { JobAppContext } from '../../GlobalState'

// display
import { Modal, Button, Input, Card, CardBody, Row, Col } from 'reactstrap'

import Link from '../partials/Link'

import { can } from '../../utils/can'
import { formatActionName } from '../../utils/action-helpers'
import { useUserActions } from '../hooks/useUserActions'
import { formatDateTime } from '../../utils/formatDate'
import useDebounce from '../hooks/useDebounce'

const ProfilePage = (props) => {

	const { user } = useContext(JobAppContext);
	
	// Filter state
	const [actionFilter, setActionFilter] = useState('')
	const [startDate, setStartDate] = useState('')
	const [endDate, setEndDate] = useState('')
	const [jobSearchInput, setJobSearchInput] = useState('')
	const debouncedJobSearch = useDebounce(jobSearchInput, 500)
	
	// Fetch user actions with filters
	const { data: userActions, isLoading: actionsLoading, error: actionsError } = useUserActions({ 
		limit: 100,
		action: actionFilter || undefined,
		startDate: startDate || undefined,
		endDate: endDate || undefined,
		jobSearch: debouncedJobSearch || undefined
	});

	// Clear all filters
	const clearFilters = () => {
		setActionFilter('')
		setStartDate('')
		setEndDate('')
		setJobSearchInput('')
	}

	const hasActiveFilters = actionFilter || startDate || endDate || jobSearchInput

	return (
		<div className='p-4'>
			<h4 className="Title">User Profile</h4>
			
			<hr />
			
			<div className="p-4">
				<div className="row">
					<div className="col-1">Name:</div>
					<div className="col-11">
						{user.name}<span style={{ 'display': 'none' }}> ( {user.cnt_id} )</span>
						{' '}( <Link to="/settings">Settings</Link> )
					</div>
				</div>
				<div className="row">
					<div className="col-1">Email:</div>
					<div className="col-11">{user.email}</div>
				</div>
				{user.memberships.map((member) => (
					<div className="row" key={member.id}>
						<div className="col-1">Company:</div>
						<div className="col-11">
							{can(['company'], user) ? (
								<Link to={`/company/${member.company.id}`}>{member.company.name}</Link>
							) : (
								member.company.name
							)}
						</div>
					</div>
				))}
			</div>

			<hr />
			
			<div className="p-4">
				<h4>Your Recent Activity</h4>
				
				{/* Summary Cards */}
				{(userActions?.summary && !hasActiveFilters) && (
					<Row className="mb-4">
						<Col md={4}>
							<Card className="text-center">
								<CardBody>
									<h5 className="text-muted mb-1">Actions This Week</h5>
									<h2 className="mb-0">{userActions.summary.this_week}</h2>
								</CardBody>
							</Card>
						</Col>
						<Col md={4}>
							<Card className="text-center">
								<CardBody>
									<h5 className="text-muted mb-1">Actions This Month</h5>
									<h2 className="mb-0">{userActions.summary.this_month}</h2>
								</CardBody>
							</Card>
						</Col>
						<Col md={4}>
							<Card className="text-center">
								<CardBody>
									<h5 className="text-muted mb-1">Total Actions</h5>
									<h2 className="mb-0">{userActions.summary.total}</h2>
								</CardBody>
							</Card>
						</Col>
					</Row>
				)}

				{/* Filter Controls */}
				<Row className="mb-3 align-items-end">
					<Col md={3}>
						<label className="form-label small text-muted">Action Type</label>
						<Input
							type="select"
							value={actionFilter}
							onChange={(e) => setActionFilter(e.target.value)}
							bsSize="sm"
						>
							<option value="">All Actions</option>
							{userActions?.available_actions?.map((action) => (
								<option key={action} value={action}>{formatActionName(action)}</option>
							))}
						</Input>
					</Col>
					<Col md={2}>
						<label className="form-label small text-muted">Start Date</label>
						<Input
							type="date"
							value={startDate}
							onChange={(e) => setStartDate(e.target.value)}
							bsSize="sm"
						/>
					</Col>
					<Col md={2}>
						<label className="form-label small text-muted">End Date</label>
						<Input
							type="date"
							value={endDate}
							onChange={(e) => setEndDate(e.target.value)}
							bsSize="sm"
						/>
					</Col>
					<Col md={3}>
						<label className="form-label small text-muted">Search Jobs</label>
						<Input
							type="text"
							placeholder="Search by job name..."
							value={jobSearchInput}
							onChange={(e) => setJobSearchInput(e.target.value)}
							bsSize="sm"
						/>
					</Col>
					<Col md={2}>
						{hasActiveFilters && (
							<Button color="secondary" size="sm" onClick={clearFilters}>
								Clear Filters
							</Button>
						)}
					</Col>
				</Row>

				{actionsLoading && <div><i className="fas fa-sync-alt fa-spin"></i> Loading recent activity...</div>}
				{actionsError && <div className="text-danger">Error loading activity: {actionsError.message}</div>}
				{userActions && userActions.stats && userActions.stats.length > 0 ? (
					<div className="table-responsive">
						<table className="table table-sm">
							<thead>
								<tr>
									<th>Date</th>
									<th>Action</th>
									<th>Job</th>
									<th>Details</th>
								</tr>
							</thead>
							<tbody>
								{userActions.stats.map((stat, index) => (
									<tr key={index}>
										<td>{formatDateTime(stat.entry_date) || 'Unknown'}</td>
										<td>{formatActionName(stat.action)}</td>
										<td>
											{stat.job && (
												<Link to={`/job/${stat.job.id}`}>
													{stat.job.name || `Job #${stat.job.id}`}
												</Link>
											)}
										</td>
										<td>{stat.parameter || 'No details'}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				) : (
					!actionsLoading && (
						<div className="text-muted">
							<p>No recent activity found.</p>
						</div>
					)
				)}
				
			</div>

		</div>
	)
}
export default ProfilePage;
